import { Box, Button, Typography } from '@mui/material';
import { JsonTable } from 'react-json-to-html';
import { getDefaultHeaders } from 'core/util/other';
import { useAuth } from 'core/contexts';
import { instance as axiosInstance, withHeaders } from 'core/util';
import React from 'react';
const BlobDetail = (props: any): React.JSX.Element => {
    /**
     * Keeping this component for now.
     * Investigate this component whenever we need to implement BLOBS.
     * (check git history if needed for deleted details file)
     *
     * Logic taken from parent component:
     *         let Component = null;
     *         if (currentNode?.sdo?.header?.type === 'BLOB') {
     *             Component = result.get('blob');
     *         } else {
     *             Component = result.get(
     *                 currentNode?.sdo?.header?.dictionary.toLowerCase()
     *             );
     *         }
     */

    const allData = props?.data?.sdo.blob;
    console.log('props', props);

    const srcHash = props?.data?.neighbors[0].source?.key;
    const srcDictionary =
        props?.data?.neighbors[0].source?.sdo?.header?.dictionary;
    const blobType = props?.data?.sdo.blob?.attribute;
    const blobHash = props?.data?.sdo.blob?.hash;
    const fileName = props?.data?.sdo.blob?.name;

    const { getToken } = useAuth();

    const uri = `/graphchain/${srcDictionary}/${srcHash}/${blobType}/${blobHash}/blobs`;
    const headers = { ...getDefaultHeaders(getToken()) };

    const handleGetBlobClick = (): void => {
        console.log('data', allData?.data?.name);

        // https://stackoverflow.com/questions/37510801/convert-octet-stream-to-image
        console.log('headers', headers);
        axiosInstance()
            .get(uri, { ...withHeaders(headers), responseType: 'blob' })
            .then((response: any) => {
                const url = window.URL.createObjectURL(
                    new Blob([response.data])
                );
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();
            });
    };

    return (
        <Box>
            <Typography
                variant='h4'
                sx={{ display: 'flex', justifyContent: ' space-between' }}
            >
                Data:
                <Button
                    onClick={handleGetBlobClick}
                    variant='contained'
                    sx={{ mb: 2 }}
                >
                    Download
                </Button>
            </Typography>
            <JsonTable json={allData} />
        </Box>
    );
};

export default BlobDetail;
